
// Import and re-export our new service for backward compatibility
import {
  ReferralStorageService,
  ReferralData,
  DEFAULT_REFERRAL_TTL
} from '@/services/referral/ReferralStorageService';

/**
 * Backward compatibility layer for existing code
 * @deprecated Use ReferralStorageService directly
 */

// Store referral code - compatibility wrapper
export function storeReferralCode(
  code: string, 
  campaign?: string,
  ttl: number = DEFAULT_REFERRAL_TTL
): void {
  ReferralStorageService.storeReferralCode(code, campaign, ttl);
}

// Get stored referral code - compatibility wrapper
export function getStoredReferralCode(): string | null {
  return ReferralStorageService.getStoredReferralCode();
}

// Get stored referral data - compatibility wrapper 
export function getStoredReferralData(): ReferralData | null {
  return ReferralStorageService.getStoredReferralData();
}

// Clear referral code - compatibility wrapper
export function clearReferralCode(): void {
  ReferralStorageService.clearReferralData();
}

// Get or create visitor ID - compatibility wrapper
export function getOrCreateVisitorId(): string {
  return ReferralStorageService.getOrCreateVisitorId();
}

/**
 * Generate app store links with proper tracking parameters
 * @param referralCode Optional referral code to include
 */
export function generateAppStoreLinks(referralCode?: string | null): { 
  appleAppStoreUrl: string, 
  googlePlayStoreUrl: string 
} {
  // Base URLs (these would be replaced with actual app store URLs)
  const baseAppleUrl = 'https://apps.apple.com/us/app/the-mat-monster/id1234567890';
  const baseGoogleUrl = 'https://play.google.com/store/apps/details?id=app.matmonster';
  
  // Get visitor ID for tracking
  const visitorId = ReferralStorageService.getOrCreateVisitorId();
  
  // Build tracking parameters
  const utmParams = new URLSearchParams({
    utm_source: 'web_app',
    utm_medium: 'referral',
    utm_campaign: referralCode ? 'user_referral' : 'direct',
    visitor_id: visitorId
  });
  
  // Add referral code if available
  if (referralCode) {
    utmParams.append('ref', referralCode);
  }
  
  // Build final URLs with parameters
  const appleAppStoreUrl = `${baseAppleUrl}?${utmParams.toString()}`;
  const googlePlayStoreUrl = `${baseGoogleUrl}&${utmParams.toString()}`;
  
  return {
    appleAppStoreUrl,
    googlePlayStoreUrl
  };
}
